import { Box, styled, useTheme } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Outlet } from 'react-router-dom';

const MainStyle = styled('main')(({ theme }) => ({
  flexGrow: 1,
}));

export default function AppLayout() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        background: theme.palette.background.neutral,
        backgroundImage: `url(/assets/img/cyan-blur.png), url(/assets/img/red-blur.png)`,
        backgroundRepeat: 'no-repeat, no-repeat',
        backgroundSize: '50%, 50%',
        backgroundPosition: 'right top, left bottom',
      }}
    >
      <Outlet />
    </Box>
  );
}
